import { render } from "./AboutUsBanner.vue?vue&type=template&id=41b58826"
import script from "./AboutUsBanner.vue?vue&type=script&lang=js"
export * from "./AboutUsBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__